export function getOffset(element) {
  const html = element.ownerDocument.documentElement;
  const box = element.getBoundingClientRect();
  return {
    top: Math.round(box.top + window.pageYOffset - html.clientTop),
    left: Math.round(box.left + window.pageXOffset - html.clientLeft),
  };
}
